import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { InsurancesService } from 'src/app/cms/insurances/insurances.service';
import { GroupService } from '../group/group.service';
import { flatMap, first } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class InsurancesPickerResolve implements Resolve<any> {

  constructor(
    private gs: GroupService,
    private insurancesService: InsurancesService
  ) { }

  resolve(route: ActivatedRouteSnapshot){
    return this.gs.getGroup().pipe(
      first(),
      flatMap(group => {
        let params = {ac_group: group, limit: 999}
        return this.insurancesService.updateInsurancesPicker(params)
      })
    )
  }
}
